import { memo } from 'react';

import { Table } from 'antd';
import type { TableColumnsType, TablePaginationConfig, TableProps } from 'antd';
import type { TableRowSelection } from 'antd/es/table/interface';

import { EMPTY_MESSAGES } from '@/shared/lib/constants';
import { TableEmpty } from '@/shared/ui/TableEmpty';

import type { ConnectorTableRow } from '@/widgets/connectors/ConnectorTableContent/model/types';

import styles from './ConnectorTableGrid.module.css';

type ConnectorTableGridProps = {
  columns: TableColumnsType<ConnectorTableRow>;
  dataSource: ConnectorTableRow[];
  rowSelection: TableRowSelection<ConnectorTableRow>;
  paginationConfig: TablePaginationConfig;
  scrollConfig: { y: string } | undefined;
  isLoading: boolean;
  onTableChange: TableProps<ConnectorTableRow>['onChange'];
};

const ConnectorTableGrid = memo(
  ({
    columns,
    dataSource,
    rowSelection,
    paginationConfig,
    scrollConfig,
    isLoading,
    onTableChange,
  }: ConnectorTableGridProps) => {
    return (
      <div className={styles.contentArea}>
        <Table<ConnectorTableRow>
          columns={columns}
          dataSource={dataSource}
          rowKey={(record) => record.id}
          rowSelection={rowSelection}
          loading={isLoading}
          pagination={paginationConfig}
          scroll={{ x: dataSource.length > 0 ? 'max-content' : undefined, ...scrollConfig }}
          sticky={true}
          className={styles.table}
          onChange={onTableChange}
          locale={{
            emptyText: <TableEmpty description={EMPTY_MESSAGES.NO_CONNECTORS} />,
          }}
        />
      </div>
    );
  }
);

ConnectorTableGrid.displayName = 'ConnectorTableGrid';

export { ConnectorTableGrid };
